module.exports = __webpack_public_path__ + "img/reject.371eed65.svg";